import React, { useState }                      from 'react'
import axios                                    from 'axios'
import Box                                      from '@material-ui/core/Box'
import { CLIENT_PUBLIC_TOKEN }                  from '../config'
import PilotCohortSourceTitleReadComponent      from './PilotCohortSourceTitleReadComponent'
import { node_server }                          from '../Helpers'

const PilotCohortSourceDeleteComponent = () => {

   /* This causes the PilotCohortSourceTitleReadComponent to re-render on the deletioon and show the
      new list of titles with the deleted one having been removed. */
   const [ data,                                setData  ]  =  useState([])

   const handleClick = (id) => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.delete(node_server + `pilotcohortsourceTable/${id}`)
         .then( res => res.data )
         .then( data => {
            setData(data.allPilotTableTitles)
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )
   }

   return(
      <Box style={{ marginTop: '6rem', marginBottom: '1rem' }} >
         <PilotCohortSourceTitleReadComponent data={data} handleClick={handleClick} />
      </Box>
   )
}

export default PilotCohortSourceDeleteComponent
